import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as o, openBlock as r, normalizeClass as s, createElementVNode as e } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBoxes",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], m = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6 .667a1.5 1.5 0 0 0-.772.214l-1.5.9A1.5 1.5 0 0 0 3 3.064v1.903L1.228 6.031A1.5 1.5 0 0 0 .5 7.314v1.622a1.5 1.5 0 0 0 .728 1.283l1.5.9a1.5 1.5 0 0 0 1.544 0L6 10.083l1.728 1.036a1.5 1.5 0 0 0 1.544 0l1.5-.9a1.5 1.5 0 0 0 .728-1.283V7.314a1.5 1.5 0 0 0-.727-1.283L9 4.967V3.064a1.5 1.5 0 0 0-.728-1.283l-1.5-.9A1.5 1.5 0 0 0 6 .667Zm-.5 8.55V7.633l-1.5.9v1.583l1.5-.9Zm1 0 1.5.899V8.533l-1.5-.9v1.584Zm0-3.35 1.5-.9V3.38l-1.5.902v1.584Zm1.026-3.368-1.268-.76a.501.501 0 0 0-.516 0l-1.267.76L6 3.417l1.526-.918ZM4 3.381v1.586l1.5.9V4.283L4 3.38ZM6.972 6.75 8.5 5.833l1.526.916-1.526.918-1.528-.917Zm3.528.88v1.304a.5.5 0 0 1-.242.427L9 10.116V8.533l1.5-.902Zm-7-1.797 1.528.917-1.528.917-1.526-.918L3.5 5.833Zm-2 3.101V7.631l1.5.902v1.583L1.742 9.36a.5.5 0 0 1-.242-.427Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  m
], f = ["id"], p = /* @__PURE__ */ e("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  p
];
function g(a, L, l, Z, I, t) {
  return r(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([t.iconSizeClass, "d-icon d-icon--boxes"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Boxes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, h, 8, u),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, v, 8, f)
    ])
  ], 10, _);
}
const x = /* @__PURE__ */ n(c, [["render", g]]);
export {
  x as default
};
//# sourceMappingURL=boxes.js.map
